export type SessionStatus = "active" | "conflict" | "unregistered";

export const shouldVerifySocket = (
  unansweredSince: number | null,
  now: number,
): boolean => unansweredSince !== null && now - unansweredSince >= 60_000;

export const sessionRecoveryAction = (
  status: SessionStatus,
  checkedSid: string | undefined,
  currentSid: string | undefined,
  connected: boolean,
): "ignore" | "reconnect" | "conflict" => {
  // An HTTP response for a replaced connection must not affect the new one.
  if (!connected || !checkedSid || checkedSid !== currentSid) return "ignore";
  if (status === "unregistered") return "reconnect";
  if (status === "conflict") return "conflict";
  return "ignore";
};
